import { createGlobalStyle } from 'styled-components';

import 'react-toastify/dist/ReactToastify.css';

export default createGlobalStyle`

  @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800&display=swap');

  *, *::before, *::after {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  html {
    scroll-behavior: smooth;
    font-size: 16px;
  }

  html, body {
    min-height: 100%;
    background-color: ${(props) => props.theme.colors.background};
    font-family: ${(props) => props.theme.fonts.text};
    color: ${(props) => props.theme.colors.text};
  }

  body, input, button, textarea, select {
    font-family: 'Inter', 'Roboto', sans-serif;
    font-size: 14px;
    line-height: 1.5;
  }

  button {
    cursor: pointer;
    &:focus {
      outline: none;
    }
  }

  input:focus,
  textarea:focus,
  select:focus {
    outline: none;
  }

  img {
    max-width: 100%;
    display: block;
  }

  a {
    color: inherit;
    text-decoration: none;
  }

  /* ── Toastify overrides ── */
  .Toastify__toast {
    border-radius: ${(props) => props.theme.sizes.borderRadius};
    font-family: 'Inter', sans-serif;
    font-size: 14px;
    font-weight: 500;
    box-shadow: ${(props) => props.theme.shadows.md};
  }

  .Toastify__toast--success {
    background-color: ${(props) => props.theme.colors.successBg};
    color: ${(props) => props.theme.colors.success};
    border-left: 4px solid ${(props) => props.theme.colors.success};
  }

  .Toastify__toast--error {
    background-color: ${(props) => props.theme.colors.errorBg};
    color: ${(props) => props.theme.colors.error};
    border-left: 4px solid ${(props) => props.theme.colors.error};
  }

  .Toastify__toast--warning {
    background-color: ${(props) => props.theme.colors.warningBg};
    color: ${(props) => props.theme.colors.warning};
    border-left: 4px solid ${(props) => props.theme.colors.warning};
  }

  .Toastify__progress-bar--success {
    background-color: ${(props) => props.theme.colors.success};
  }

  .Toastify__progress-bar--error {
    background-color: ${(props) => props.theme.colors.error};
  }

  /* ── Scrollbar estilizada ── */
  ::-webkit-scrollbar {
    width: 6px;
    height: 6px;
  }
  ::-webkit-scrollbar-track {
    background: ${(props) => props.theme.colors.surface};
  }
  ::-webkit-scrollbar-thumb {
    background: ${(props) => props.theme.colors.border};
    border-radius: 99px;
  }
  ::-webkit-scrollbar-thumb:hover {
    background: ${(props) => props.theme.colors.textMuted};
  }

  /* ── Animações globais ── */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(12px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  @keyframes fadeIn {
    from { opacity: 0; }
    to   { opacity: 1; }
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }

  @keyframes pulse {
    0%, 100% { opacity: 1; }
    50%       { opacity: 0.5; }
  }
`;
